import { BidContext } from "./BidContext"
import { useState } from "react"
import { toast } from "react-toastify"
import { placeBidService } from "../../global-services/bids.service"

const BidProvider = ({ children }) => {
  const [amount, setAmount] = useState("")
  const [timeline, setTimeline] = useState("")
  const [message, setMessage] = useState("")
  const [loading, setLoading] = useState(false)
  const [isBidPlaced, setIsBidPlaced] = useState(false)
  const [bidData, setBidData] = useState(null)

  const submitBid = async (postId, clientId, clientAuthId, extraData = {}) => {
    if (loading) return
    try {
      setLoading(true)
      setIsBidPlaced(false)

      const bidData = {
        postId,
        amount: extraData.amount || amount,
        timeline: extraData.timeline || timeline,
        message: extraData.message || message,
        clientId,
        clientAuthId
      }

      await placeBidService(bidData)

      toast.success("Bid submitted successfully")
      setIsBidPlaced(true)
      setAmount("");
      setTimeline("");
      setMessage("");
    } catch (err) {
      toast.error(err.message)
      setIsBidPlaced(false)
    } finally {
      setLoading(false)
    }
  }

  return (
    <BidContext.Provider
      value={{
        amount,
        setAmount,
        timeline,
        setTimeline,
        message,
        setMessage,
        loading,
        isBidPlaced,
        bidData,
        submitBid,
        setIsBidPlaced,
        setBidData
      }}
    >
      {children}
    </BidContext.Provider>
  )
}

export default BidProvider
